














































































































































































import { Vue, Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { Competency, CompetencySelection } from '@/models/competency/competency';
import { masterModule } from '@/store/modules/entities/master.module';
import GExamCreateSelection from '@/views/GExamCreate/QuestionSetting/GExamCreateQuestionSettingCompetencySelection.vue';
import GExamCreateFormFormat from '@/views/GExamCreate/GExamCreateFormFormat.vue';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { GPageBase } from '@/mixins';
import GVTag from '@/components/GVTag.vue';
import { GEnum } from '@/constants/enum.defination';
import { jgrowStatusModule } from '@/store/modules/frames/jgrow-status.module';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import { CustomCompetency } from '@/models/competency/competency';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';

@Component({
  name: 'GExamCreateQuestionSettingDetail',
  components: { GVTag, GExamCreateFormFormat, GExamCreateSelection, GCompetencyLabel },
  computed: {},
  methods: {},
})
export default class GExamCreateQuestionSettingDetail extends Mixins(GPageBase) {
  @Prop() isDisable: boolean;


  showModal: boolean = false;
  newCustomCompetencyName: string = "";
  emptyError: boolean = true;
  sameNameError: boolean = false;

  mounted() {}

  get radioLabelPermitOnlySameCourseStudents(): GEnum.EvaluationRequestPermissionCategory {
    return GEnum.EvaluationRequestPermissionCategory.PermitOnlySameCourseStudents;
  }

  get radioLabelPermitOnlySameSchoolStudents(): GEnum.EvaluationRequestPermissionCategory {
    return GEnum.EvaluationRequestPermissionCategory.PermitOnlySameSchoolStudents;
  }

  get radioLabelPermitContainGuest(): GEnum.EvaluationRequestPermissionCategory {
    return GEnum.EvaluationRequestPermissionCategory.PermitContainGuest;
  }

  get radioLabelNotPermit(): GEnum.EvaluationRequestPermissionCategory {
    return GEnum.EvaluationRequestPermissionCategory.NotPermit;
  }

  get selectionCognitive(): CompetencySelection {
    return examCreateModule.selectionCognitive;
  }
  get selectionSelf(): CompetencySelection {
    return examCreateModule.selectionSelf;
  }
  get selectionGift(): CompetencySelection {
    return examCreateModule.selectionGift;
  }
  get selectionCommunity(): CompetencySelection {
    return examCreateModule.selectionCommunity;
  }

  get competencyCognitiveIncludeIsValid(): Competency[] {
    return masterModule.competencyCognitiveIncludeIsValid;
  }

  get competencySelfIncludeIsValid(): Competency[] {
    return masterModule.competencySelfIncludeIsValid;
  }

  get competencyGiftIncludeIsValid(): Competency[] {
    return masterModule.competencyGiftIncludeIsValid;
  }

  get competencyCommunityIncludeIsValid(): Competency[] {
    return masterModule.competencyCommunityIncludeIsValid;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get evalSettingModeEditAndUnderExamination(): boolean {
    return examCreateModule.evalSettingModeEdit && this.evalSettingDetail.isUnderExamination;
  }

  get isNonCompetencySelected(): boolean {
    return (
      (this.evalSettingDetail.giftRequired || this.evalSettingDetail.selfEvalRequired) &&
      this.selectionCognitive.checkAllGroup.length === 0 &&
      this.selectionSelf.checkAllGroup.length === 0 &&
      this.selectionGift.checkAllGroup.length === 0 &&
      this.selectionCommunity.checkAllGroup.length === 0
    );
  }

  get isEvalItemAllUnchecked(): boolean {
    return !this.evalSettingDetail.iatRequired && !this.evalSettingDetail.selfEvalRequired && !this.evalSettingDetail.giftRequired && !this.evalSettingDetail.trendRequired;
  }

  get isJgrow(): boolean {
    return jgrowStatusModule.isJgrow;
  }

  /**
   * 内田洋行タイプ
   */
  get isDispCtrlTypeUchida(): boolean {
    return this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida;
  }

  get competencyMap(): Map<number, Competency> {
    return masterModule.competencyMap;
  }

  /**
   * 選択済みコンピテンシーID
   */
  get selectCompetencyIDs(): number[] {
    return examCreateModule.selectedCompetencyIDs;
  }

  isValid(): boolean {
    return !this.isNonCompetencySelected && !this.isEvalItemAllUnchecked;
  }

  handleExam() {
    // 自己評価・相互評価がチェックされていない、かつ画面制御タイプが内田洋行でなければ選択されているコンピテンシーをクリア
    // 内田洋行の場合はコンピテンシーは固定のためクリアしない
    if (!this.evalSettingDetail.selfEvalRequired && !this.evalSettingDetail.giftRequired && !this.isDispCtrlTypeUchida) {
      examCreateModule.cleanCompetencySelections();
    }
  }

  /**
   * 学校コンピテンシー登録時、名前が未入力をチェック
   */
  checkEmptyName() {
    return this.newCustomCompetencyName === null || this.newCustomCompetencyName === undefined || this.newCustomCompetencyName === '';
  }

  /**
   * 学校コンピテンシー登録時、既存と同名チェック
   */
  checkSameName() {
    let sameNameCc: CustomCompetency = undefined;
    sameNameCc = customCompetencyModule.customCompetencies.find((cc: CustomCompetency) => {
      return cc.name === this.newCustomCompetencyName;
    });

    if (sameNameCc) {
      this.sameNameError = true;
      return true;
    }

    this.sameNameError = false;
    return false;
  }

  /**
   * 学校コンピテンシー登録時、コンピテンシー名の入力で未入力 & 既存と同名チェック
   */
  checkName() {
    if (this.checkSameName()) {
      this.sameNameError = true;
    } else {
      this.sameNameError = false;
    }

    if (this.checkEmptyName()) {
      this.emptyError = true;
    } else {
      this.emptyError = false;
    }
    return !this.sameNameError && !this.emptyError;
  }

  /**
   * 学校コンピテンシーの新規追加
   */
  handleCreate() {
    // 同名でもなく、空でもない かつ、コンピテンシーが選択されている場合は登録
    if (!this.sameNameError && !this.emptyError && this.selectCompetencyIDs.length > 0) {
      customCompetencyModule.createCustomCompetency.name = this.newCustomCompetencyName;
      customCompetencyModule.createCustomCompetency.competencyIDs = this.selectCompetencyIDs;
      customCompetencyModule.addCustomCompetencyAtEvalSetting().then(async () => {
        this.showInsertSuccessed();
        this.newCustomCompetencyName = "";
        customCompetencyModule.clean();
        await customCompetencyModule.fetchCustomCompetency();
        this.showModal = false;
      }).catch(() => {
        this.showInsertFailed();
      });
    }
  }

  @Watch('evalSettingDetail.giftRequired')
  watchGiftRequired(newValue: boolean) {
    if (!newValue) {
      // 各設定値をリセット
      this.evalSettingDetail.requiredRespondents = 3;
      this.evalSettingDetail.isEvaluatorVisibleRadio = GEnum.RadioLabel.False;
      this.evalSettingDetail.evaluationRequestPermissionCategory = GEnum.EvaluationRequestPermissionCategory.NotPermit;
      this.evalSettingDetail.freeWordSkillRequiredRadio = GEnum.RadioLabel.False;
    }
  }
}
